<template>
  <Loader v-if="loader" />
  <div class="card">
    <h3> Andamento Agenti </h3>
    <div class="flex justify-content-start align-items-center">
      <label>Agenti</label>
      <InputSwitch v-model="view_point" class="m-2" @update:modelValue="onChangeView_point" />
      <label>Point</label>
    <Dropdown v-model="selectedAgent" :options="agents" filter placeholder="Seleziona un agente"
      class="w-full md:w-100rem ml-3" optionLabel="name" v-if="!view_point" @update:modelValue="getData()" />
    </div>
    <div class="card" v-if="loaded_items">
      <DataTable :value="items" tableStyle="w-full" v-model:filters="filters" filterDisplay="row" rowGroupMode="rowspan"
        groupRowsBy="agente">
        <template #empty>
          Nessun risultato
        </template>
        <template #header>
          <div class="flex justify-content-end">
            <Button icon="pi pi-download" label="Esporta" class="p-button-secondary"  @click="exportAndamento" />
          </div>
        </template>
        <Column v-for="col of columns" :key="col.field" :field="col.field" :type="col.type">
          <template #header>
            <div class="flex flex-column">
              {{ col.header }}
              <small v-if="dettagliTipiRid.includes(col.field)">
                (Importo Rid)
              </small>
            </div>
          </template>
          <template #body="{ data }">
            <div v-if="col.type == 'link'">
              <Button class="p-button-link" :label="data[col.field]" @click="goTo($event, data, col.field)" />
            </div>
            <div v-else-if="col.type == 'price'">
              <Button v-if="col.field == 'totaleInsoluto'" class="p-button-link"
                @click="openDialogDettaglioFatture(data)">
                <div class="flex flex-column">
                  {{ formatCurrency(data[col.field]) }}
                  <small>{{ formatCurrency(data[`${col.field}Tipo3`]) }}</small>
                </div>
              </Button>
              <div v-else>
                <div v-if="dettagliTipiRid.includes(col.field)" class="flex flex-column" style="font-size: larger;">
                  <strong>{{ formatCurrency(data[col.field]) }}</strong>
                  <small>{{ formatCurrency(data[`${col.field}Tipo3`]) }}</small>
                </div>
                <div v-else>
                  {{ formatCurrency(data[col.field]) }}
                </div>
              </div>
            </div>
            <div v-else-if="col.type == 'percent'">
              {{ data[col.field].toFixed(2) }} %
            </div>
            <div v-else-if="col.type == 'data'">
              {{ data[col.field] != null ? moment(data[col.field]).format('MM/Y') : data[col.field] }}
            </div>
            <div v-else class="flex flex-column">
              <p :class="[{'fb-2': col.field == 'agente'}]">{{ data[col.field] }}</p>
              <div v-if="col.field == 'agente' && data['is_point']" style="font-size: smaller;">
                Point di {{ data['agente_master'] }}
              </div>
            </div>
          </template>
          <template #filter="{ filterModel, filterCallback }" v-if="col.field == 'agente' || col.field == 'meseEmissioneFormattato'">
            <Dropdown v-if="col.field == 'agente'" v-model="filterModel.value" @change="filterCallback()" :options="agenti_in_filter" filter placeholder="Filtra" class="p-column-filter" style="min-width: 12rem" :showClear="true" optionValue="name" optionLabel="name" @update:modelValue="calculateTotal(filterModel.value, 'agente')">
              <template #option="{option}">
                <div><strong>{{ option.name }}</strong> <span v-if="option.is_point">di {{ option.agente_master }}</span></div>
              </template>
            </Dropdown>
            <Dropdown v-else v-model="filterModel.value" @change="filterCallback()" :options="mesi_in_filter" filter
              placeholder="Filtra" class="p-column-filter" style="min-width: 12rem" :showClear="true"
              @update:modelValue="calculateTotal(filterModel.value, 'meseEmissioneFormattato')"></Dropdown>
          </template>
        </Column>
        <ColumnGroup type="footer">
          <Row>
            <Column :colspan="1" class="td-footer" footer="Totali" />
            <Column :colspan="2" class="td-footer" />
            <Column :colspan="1" class="td-footer" :footer="totals.quanteFatture" />
            <Column :colspan="1" class="td-footer">
              <template #footer>
                <div class="flex flex-column">
                  {{ totals.totaleFatturato }}
                  <small>
                    {{ totals.totaleFatturatoTipo3 }}
                  </small>
                </div>
              </template>
            </Column>
            <Column :colspan="1" class="td-footer">
              <template #footer>
                <div class="flex flex-column">
                  {{ totals.totalePagato }}
                  <small>
                    {{ totals.totalePagatoTipo3 }}
                  </small>
                </div>
              </template>
            </Column>
            <Column :colspan="1" class="td-footer ml-4">
              <template #footer>
                <div class="flex flex-column">
                  {{ totals.totaleInsoluto }}
                  <small>
                    {{ totals.totaleInsolutoTipo3 }}
                  </small>
                </div>
              </template>
            </Column>
            <Column :colspan="1" class="td-footer ml-4" :footer="totals.totaleInsolutoCessati" />
            <Column :colspan="1" class="td-footer ml-4" :footer="totals.totaleInsolutoInSospensione" />
          </Row>
        </ColumnGroup>
      </DataTable>
    </div>
  </div>
  <Dialog v-model:visible="visibleDialogDettaglioFatture" maximizable modal header="Dettaglio Fatture"
    :style="{ width: '70rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
    <template #header class="flex align-itmes-center">
      <h3 class="mb-0">
        {{ detail.header }}
      </h3>
      <Button icon="pi pi-download" label="Esporta" class="p-button-secondary" @click="exportCSV($event)" />
    </template>
    <DataTable :value="detail.items" class="w-full" :rowClass="rowDetailClass" ref="dt" sortField="saldo"
      :sortOrder="-1">
      <Column v-for="col of columnsDetail" :key="col.field" :field="col.field" :header="col.header"
        :sortable="['saldo'].includes(col.field)">
        <template #body="{ data }">
          <div v-if="col.type == 'link'">
            <Button :class="buttonClass(data)" :label="data[col.field]" @click="goTo($event, data, col.field)" />
          </div>
          <div v-else-if="col.type == 'price'">
            {{ formatCurrency(data[col.field]) }}
          </div>
          <div v-else-if="col.type == 'percent'">
            {{ data[col.field].toFixed(2) }} %
          </div>
          <div v-else-if="col.type == 'data'">
            {{ data[col.field] != null ? moment(data[col.field]).format('DD/MM/Y') : data[col.field] }}
          </div>
          <div v-else-if="col.type == 'stato'">
            {{ legendaStatiFornitura.find(item => item.id == data[col.field]).name }}
          </div>
          <div v-else>
            {{ data[col.field] }}
          </div>
        </template>
      </Column>
    </DataTable>
  </Dialog>
</template>

<script>
import Service from '@/services/ask-management/contratti-vendita-service'
import VolturaService from '@/services/ask-operation/voltura-service'
import UtilityService from '@/services/ask-management/utility-service'

import { ref, onMounted, getCurrentInstance } from 'vue';
import Loader from '@/components/Loader.vue'
import moment from 'moment'
import { FilterMatchMode } from 'primevue/api';
import { useRoute } from 'vue-router'
import { useToast } from 'primevue/usetoast';


export default {
  components: {
    Loader
  },
  setup() {
    const toast = useToast();
    const route = useRoute()
    const parametri = route.params
    const loader = ref(false)
    const loaded_items = ref(false)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const serviceVoltura = new VolturaService(self.$http, self.$eventBus)
    const utilityService = new UtilityService(self.$http, self.$eventBus)
    const selectedAgent = ref()
    const agenti_in_filter = ref()
    const mesi_in_filter = ref()
    const allAgents = ref([])
    const agents = ref([])
    const point = ref([])
    const view_point = ref()
    const view_parametri = ref(true)
    const items = ref([])
    const columnsPoint = [
      { field: 'agente', header: 'Point' },
      { field: 'meseEmissioneFormattato', header: 'Mese di Emissione' },
      { field: 'percentuale', header: 'Percentuale', type: 'percent' },
      { field: 'quanteFatture', header: 'Numero fatture' },
      { field: 'totaleFatturato', header: 'Tot. Importo fatturato', type: 'price' },
      { field: 'totalePagato', header: 'Tot. Importo Pagato', type: 'price' },
      { field: 'totaleInsoluto', header: 'Totale Importo Insoluto', type: 'price' },
      { field: 'totaleInsolutoCessati', header: 'Totale Importo Insoluto Cessati', type: 'price' },
      { field: 'totaleInsolutoInSospensione', header: 'Totale Importo Insoluto In Sospensione', type: 'price' },
    ];
    const columnsAgente = [
      { field: 'agente', header: 'Agente' },
      { field: 'meseEmissioneFormattato', header: 'Mese di Emissione' },
      { field: 'percentuale', header: 'Percentuale', type: 'percent' },
      { field: 'quanteFatture', header: 'Numero fatture' },
      { field: 'totaleFatturato', header: 'Tot. Importo fatturato', type: 'price' },
      { field: 'totalePagato', header: 'Tot. Importo Pagato', type: 'price' },
      { field: 'totaleInsoluto', header: 'Tot. Importo Insoluto', type: 'price' },
      { field: 'totaleInsolutoCessati', header: 'Tot. Importo Insoluto Cessati', type: 'price' },
      { field: 'totaleInsolutoInSospensione', header: 'Tot. Importo Insoluto In Sospensione', type: 'price' },
    ];
    const columnsDetail = [
      { field: 'numero', header: 'Numero fattura', type: 'link' },
      { field: 'data_emissione', header: 'Data Emissione', type: 'data' },
      { field: 'data_scadenza', header: 'Data Scadenza', type: 'data' },
      { field: 'cliente_name', header: 'Nome cliente', type: 'link' },
      { field: 'saldo', header: 'Da saldare', type: 'price' },
      { field: 'type_state', header: 'Stato fornitura' }
    ];
    const dettagliTipiRid = ref([
      'totaleFatturato', 'totalePagato', 'totaleInsoluto'
    ])
    const dt = ref();
    const filters = ref({
      agente: { value: null, matchMode: FilterMatchMode.EQUALS },
      meseEmissioneFormattato: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
    const columns = ref()
    const visibleDialogDettaglioFatture = ref(false)
    const detail = ref({
      header: null,
      items: []
    })
    const legendaStatiFornitura = ref([])

    const custom_filter = ref({
      agente: null,
      meseEmissioneFormattato: null
    })

    const totals = ref({
      quanteFatture: 0,
      totaleFatturato: 0,
      totalePagato: 0,
      totaleInsoluto: 0,
      totaleInsolutoCessati: 0,
      totaleInsolutoInSospensione: 0,
      totaleFatturatoTipo3: 0,
      totalePagatoTipo3: 0,
      totaleInsolutoTipo3: 0
    })
    const geTipiStatoFornitura = () => {
      utilityService.geTipiStatoFornitura().then((res) => {
        legendaStatiFornitura.value = res.items
        legendaStatiFornitura.value.push({ id: 0, name: 'Non identificato' })
      })
    }

    onMounted(() => {
      loader.value = true

      Promise.all([getAgents(), geTipiStatoFornitura()])
        .then(() => {
          setView_point()
        })
        .finally(() => {
          Promise.all([getData()])
            .finally(() => {
              view_parametri.value = false
              loader.value = false
            })
        })

    })

    const setView_point = () => {
      columns.value = columnsPoint
      view_point.value = true
      agenti_in_filter.value = point.value
      if (parametri.type) {
        view_point.value = parametri.type == 'point'
        if (!view_point.value) {
          columns.value = columnsAgente
          selectedAgent.value = allAgents.value.find(agent => agent.id == parametri.id)
        } else {
          filters.value.agente.value = allAgents.value.find(agent => agent.id == parametri.id).name
        }
      }
    }
    const onChangeView_point = () => {
      initItems()

      if (view_point.value) {
        selectedAgent.value = null
        getData()
        columns.value = columnsPoint
      } else {
        columns.value = columnsAgente
      }
      filters.value.agente.value = null
    }

    const getAgents = async () => {
      await serviceVoltura.getAgenti()
        .then((res) => {
          allAgents.value = res.items
          agents.value = res.items.filter(agent => !agent.is_point).sort(comparaNome)
          point.value = res.items.filter(agent => agent.is_point).sort(comparaNome)
        })
    }
    const comparaNome = (a, b) => {
      // converting to uppercase to have case-insensitive comparison
      const name1 = a.name.toUpperCase();
      const name2 = b.name.toUpperCase();

      let comparison = 0;

      if (name1 > name2) {
        comparison = 1;
      } else if (name1 < name2) {
        comparison = -1;
      }
      return comparison;
    }

    const initItems = () => {
      items.value = []
      loaded_items.value = false
    }
    const getData = async () => {
      initItems()
      loader.value = true

      let fd = new FormData()

      let id_agente = view_point.value ? '' : selectedAgent.value.id
      fd.append('id_agente', id_agente)

      await service.getAndamentoAgenti(fd)
        .then((res) => {
          let mesi = []
          if (view_point.value) {
            res.items.forEach(item => {
              item.meseEmissioneFormattato = moment(item.meseEmissione).format('MM/Y')
              mesi.push(moment(item.meseEmissione).format('MM/Y'))
            })
          } else {
            res.items.report.forEach(item => {
              item.meseEmissioneFormattato = moment(item.meseEmissione).format('MM/Y')
              mesi.push(moment(item.meseEmissione).format('MM/Y'))
            })
          }
          
          items.value = view_point.value ? res.items : res.items.report
          agenti_in_filter.value = view_point.value ? point.value : allAgents.value.filter(agent => res.items.agenti.includes(agent.id)).sort(comparaNome)
          
          const dateObjects = mesi.map(dateString => {
            const [month, year] = dateString.split('/');
            return new Date(year, month - 1);
          });
          
          dateObjects.sort((a, b) => b - a);
          
          mesi_in_filter.value = dateObjects.map(date => {
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${month}/${year}`;
          });
          mesi_in_filter.value = [...new Set(mesi_in_filter.value)]
          
          let filtro = null
          let type = null

          if (parametri.type && view_parametri.value) {
            view_point.value = parametri.type == 'point'
            type = 'agente'
            if (view_point.value) {
              filtro = filters.value.agente.value
            }
          }
          loaded_items.value = true

          calculateTotal(filtro, type)
        }).finally(() => {
          loader.value = false
        })
    }

    const goTo = (evt, data, type_path) => {
      let path
      let type_data
      switch (type_path) {
        case 'cliente_name':
          path = `clienti`
          type_data = `cliente_id`
          break;
        case 'numero':
          path = `clienti/fatture`
          type_data = type_path
          break;
        case 'code':
          path = data.type_pp
          type_data = 'supply_id'
          break;
        case 'contratto_code':
          path = 'contratti/vendita'
          type_data = 'contratto_id'
          break;

        default:
          path = `${data.type_fornitura}s`
          type_data = `id_${data.type_fornitura}`
          break;
      }
      window.open(`/ask/${path}/${data[type_data]}/dettagli`, '_blank')
    }

    const openDialogDettaglioFatture = async (data) => {
      loader.value = true
      let fd = new FormData()

      fd.append('id_agente', data.id)
      fd.append('mese', data.meseEmissione)
      detail.value = {
        header: null,
        items: []
      }

      await service.getDetailAndamentoAgenti(fd)
        .then((res) => {
          detail.value.header = `Dettaglio fatture di ${data.agente} del mese ${data.meseEmissioneFormattato}`
          res.items.forEach(item => {
            item.type_state = legendaStatiFornitura.value.find(el => el.id == item.type_state).name
          })
          detail.value.items = res.items
        }).finally(() => {
          loader.value = false
          visibleDialogDettaglioFatture.value = true
        })
    }
    const rowDetailClass = (data) => {
      return [{ 'bg-danger': data.type_state == 16 }];
    };
    const buttonClass = (data) => {
      return [{ 'p-button-color-white': data.type_state == 16 }, { 'p-button-link': data.type_state != 16 }];
    };

    const calculateTotal = (filtro = null, type_prop = null) => {
      let prop_to_sum = [
        'quanteFatture',
        'totaleFatturato',
        'totalePagato',
        'totaleInsoluto',
        'totaleInsolutoCessati',
        'totaleInsolutoInSospensione',
        'totaleFatturatoTipo3',
        'totalePagatoTipo3',
        'totaleInsolutoTipo3'
      ]
      if (filtro) {
        custom_filter.value[type_prop] = String(filtro)
      } else if (type_prop) {
        custom_filter.value[type_prop] = null
      } else {
        custom_filter.value = {
          agente: null,
          meseEmissioneFomattato: null
        }
      }

      let items_filtered = Array.from(items.value)
      Object.keys(custom_filter.value).forEach(filter => {
        if (custom_filter.value[filter]) {
          items_filtered = items_filtered.filter(item => item[filter] == custom_filter.value[filter])
        }
      })

      prop_to_sum.forEach(prop => {
        let total = 0;
        for (let el of items_filtered) {
          total += el[prop];
        }
        totals.value[prop] = prop != 'quanteFatture' ? formatCurrency(total) : total
      })
    }
    const formatCurrency = (value) => {
      return value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    };

    const exportCSV = () => {
      dt.value.exportCSV();
    };

    const exportAndamento = async () => {
      let filtered = [...items.value]

      Object.keys(filters.value).forEach((filtro) => {
        if (filtro != 'global') {
          if (filters.value[filtro].value != null) {
            filtered = filtered.filter(item => item[filtro] == filters.value[filtro].value)
          }
        }
      })

      if (filtered.length) {
        loader.value = true

        await service.downloadPdfAndamento(JSON.stringify(filtered))
          .finally(() => {
            loader.value = false
          })
      } else {
        toast.add({ severity: 'warn', detail: 'Non ci sono caricamenti da esportare con i filtri selezionati', life: 5000 })
      }
    }

    return {
      selectedAgent,
      agents,
      view_point,
      items,
      onChangeView_point,
      loaded_items,
      columnsPoint,
      moment,
      loader,
      service,
      getData,
      columnsAgente,
      columns,
      point,
      filters,
      goTo,
      openDialogDettaglioFatture,
      visibleDialogDettaglioFatture,
      detail,
      columnsDetail,
      rowDetailClass,
      calculateTotal,
      totals,
      formatCurrency,
      buttonClass,
      agenti_in_filter,
      mesi_in_filter,
      legendaStatiFornitura,
      exportCSV,
      dt,
      dettagliTipiRid,
      exportAndamento,
    }
  }
}
</script>

<style>
.fb-2{
  font-weight:700
}
.p-point {
  text-transform: capitalize;
  color: rgb(0, 102, 255);
  font-weight: 600;
}
</style>